import MatUITable from "../../../components/MatUITable/MatUITable";
import Heading from "../../../components/Heading/Heading";
import { ordersColumns } from "../../../utils/Data/dataTexts";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";
function Orders({ orders }) {
  const filterShipmentsFromOrders = () => {
    let rowData = [];
    orders.forEach((order) => {
      let processed = false;
      for (let j in order.etr) {
        if (order.etr[j].length > 0 || order.status !== "processing") {
          processed = true;
        }
      }
      if (processed === true) {
        rowData.push(order);
      }
    });
    return rowData;
  };
  return (
    <>
      <div className="DashboardContent">
        <Heading title={i18n.t("dashboardmenu.shipments")} />
        <MatUITable
          paging={true}
          pageSize={5}
          page="orders"
          columns={ordersColumns}
          data={filterShipmentsFromOrders()}
        />
      </div>
    </>
  );
}

export default withTranslation()(Orders);
